/** Texts of the objects pages (de), below `projects.objects`. */
export const objects = {
  title: 'Objekte',
  description: 'Gebäude und Liegenschaften, an denen Projekte stattfinden, mit ihrer Geschichte.',
  new: 'Neues Objekt',
  search: 'Objekte durchsuchen',
  searchPlaceholder: 'Name, Nummer, Nr. beim Kunden, Adresse, Eigentümer …',
  archive: 'Archiv',
  current: 'Aktuell',
  archived: 'Archiviert',
  specialBuilding: 'Sonderbau',
  georeferenced: 'GPS-Verortung',
  buildingClassValue: 'GK {{value}}',
  yes: 'Ja',
  no: 'Nein',
  exportName: 'Objekte',
  views: 'Darstellung',
  list: 'Liste',
  map: 'Karte',
  mapLabel: 'Objekte auf der Karte',
  mapEmpty: 'Kein Objekt auf der Karte',
  mapEmptyHint: 'Objekte erscheinen hier, sobald ihre Adresse über die Adresssuche gewählt wurde.',
  notOnMap: 'nicht auf der Karte',
  empty: 'Noch keine Objekte',
  emptyHint: 'Mit „Neues Objekt“ das erste Gebäude anlegen.',
  emptyReadOnly: 'Angelegte Objekte erscheinen hier.',
  noMatches: 'Keine passenden Objekte',
  noMatchesHint: 'Suche oder Filter ändern.',
  fields: {
    project: 'Projekt',
    name: 'Bezeichnung',
    number: 'Objektnummer',
    customerNumber: 'Objektnummer des Kunden',
    customerNumberShort: 'Nr. beim Kunden',
    address: 'Adresse',
    street: 'Straße',
    houseNumber: 'Hausnummer',
    postcode: 'PLZ',
    city: 'Ort',
    countryCode: 'Land',
    state: 'Bundesland',
    owner: 'Eigentümer',
    operator: 'Betreiber',
    usage: 'Nutzung',
    buildingClass: 'Gebäudeklasse',
    buildingClassShort: 'GK',
    specialBuilding: 'Sonderbau',
    georeferenced: 'Mängel per GPS verorten',
    notes: 'Notizen',
    projectCount: 'Projekte',
  },
  form: {
    createTitle: 'Neues Objekt',
    editTitle: 'Objekt bearbeiten',
    more: 'Weitere Angaben',
    created: 'Objekt „{{name}}“ angelegt.',
    updated: 'Änderungen gespeichert.',
    projectHint:
      'Das Projekt, zu dem das Gebäude gehört. Weitere Projekte lassen sich später auf der Projektseite zuordnen.',
    nameHint: 'Wie das Gebäude im Büro genannt wird, z. B. „Grundschule am Hafen“.',
    numberHint:
      'Die Firma vergibt Objektnummern von Hand. Ohne Eingabe bleibt das Objekt ohne Nummer.',
    customerNumberHint:
      'Nummer, unter der der Kunde das Gebäude führt, z. B. die Liegenschaftsnummer. Die eigene Objektnummer bleibt davon unberührt.',
    address: 'Adresse',
    addressSearch: 'Adresse suchen',
    addressSearchHint: 'Füllt Straße und Ort aus und setzt den Punkt auf der Karte.',
    pointHint:
      'Setzt die Adresssuche. Für Orte ohne passende Adresse, z. B. eine Baustelle, den Punkt auf der Karte wählen, Koordinaten eingeben oder den eigenen Standort nehmen.',
    notLocated: 'Noch kein Punkt: Das Objekt erscheint nicht auf Karten.',
    stateHint:
      'Vorschlag aus der Adresssuche. Bestimmt, welches Landesrecht gilt, z. B. bei Begehungen.',
    noState: 'Keine Angabe',
    usageHint: 'Z. B. Büro, Schule, Krankenhaus, Versammlungsstätte.',
    noBuildingClass: 'Keine Angabe',
    specialBuildingHint: 'Sonderbau nach Landesbauordnung, z. B. Hochhaus oder Krankenhaus.',
    georeferencedHint:
      'Für Strecken wie Gleis- oder Straßenbaustellen: Begehungen am Objekt verorten Mängel dann mit GPS auf einer Karte statt auf Plänen. Jede Begehung kann es selbst umstellen.',
    reload: 'Neu laden',
    conflictHint:
      'Neu laden zeigt den aktuellen Stand. Eigene Eingaben in diesem Dialog gehen dabei verloren.',
  },
  page: {
    masterData: 'Stammdaten',
    masterDataEmpty: 'Noch keine Nummer, Adresse, Eigentümer oder Gebäudedaten.',
    location: 'Lage',
    mapLabel: 'Lage von {{name}}',
    changed: 'geändert {{when}}',
    customerNumber: 'beim Kunden {{number}}',
    notFound: 'Objekt nicht gefunden',
    notFoundHint:
      'Die Adresse ist falsch, das Objekt wurde gelöscht oder gehört zu einer anderen Firma.',
    archive: 'Archivieren',
    archiveTitle: 'Objekt archivieren?',
    archiveDescription:
      '„{{name}}“ fehlt danach in der Liste und in Auswahlfeldern. Projekte behalten den Verweis, Zurückholen ist jederzeit möglich.',
    archivedToast: 'Objekt archiviert.',
    archivedTitle: 'Archiviert',
    archivedSince: 'Seit {{when}}. Archivierte Objekte fehlen in Auswahlfeldern.',
    restore: 'Zurückholen',
    restored: 'Objekt zurückgeholt.',
    projects: 'Projekte am Objekt',
    projectsHint: 'Alle Projekte an diesem Gebäude, die du sehen darfst.',
    projectsOf: 'Projekte an {{name}}',
    projectNumber: 'Nummer',
    projectTitle: 'Projekt',
    projectStatus: 'Status',
    projectPeriod: 'Zeitraum',
    noProjects: 'Noch keine Projekte',
    noProjectsHint: 'Projekte erscheinen hier, sobald sie dieses Objekt angeben.',
    projectClient: 'Auftraggeber',
    createProject: 'Projekt anlegen',
  },
  federalStates: {
    BW: 'Baden-Württemberg',
    BY: 'Bayern',
    BE: 'Berlin',
    BB: 'Brandenburg',
    HB: 'Bremen',
    HH: 'Hamburg',
    HE: 'Hessen',
    MV: 'Mecklenburg-Vorpommern',
    NI: 'Niedersachsen',
    NW: 'Nordrhein-Westfalen',
    RP: 'Rheinland-Pfalz',
    SL: 'Saarland',
    SN: 'Sachsen',
    ST: 'Sachsen-Anhalt',
    SH: 'Schleswig-Holstein',
    TH: 'Thüringen',
  },
  section: {
    caption: 'Objekte dieser Organisation',
    empty: 'Keine Objekte',
    emptyHint:
      'Objekte, deren Eigentümer oder Betreiber die Organisation ist, und die Objekte ihrer Projekte erscheinen hier.',
    relation: 'Zuordnung',
    owner: 'Eigentümer',
    operator: 'Betreiber',
    project: 'Projekt {{number}}',
  },
  picker: {
    placeholder: 'Objekt auswählen',
    search: 'Bezeichnung, Nummer oder Ort suchen',
    customerNumber: 'Kunde: {{number}}',
    empty: 'Kein Objekt gefunden.',
    create: 'Objekt anlegen',
    createNamed: '„{{name}}“ als Objekt anlegen',
    loading: 'Wird geladen …',
    unavailable: 'Nicht verfügbar',
  },
  errors: {
    name: 'Bezeichnung eingeben.',
    countryCode: 'Ländercode mit zwei Buchstaben eingeben, z. B. DE.',
    coordinates: 'Koordinaten unvollständig. Adresse erneut über die Suche wählen.',
    buildingClass: 'Gebäudeklasse 1 bis 5 wählen.',
    state: 'Bundesland aus der Liste wählen.',
    organization: 'Die gewählte Organisation ist nicht mehr verfügbar.',
    invalid: 'Eingabe prüfen.',
    invalidInput: 'Eingaben prüfen.',
    versionConflict: 'Inzwischen von jemand anderem geändert.',
    notFound: 'Objekt nicht gefunden. Vielleicht wurde es gelöscht.',
    forbidden: 'Dafür fehlt eine Berechtigung.',
  },
};
